function Footer() {
  return (
    <section className="footer-wrap py-3">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-item-center m-0 text-secondary text-small flex-wrap">
              <div className="copyright">
                &copy;&nbsp;
                <small>
                  Copyright Gauweng SA PTY LTD {new Date().getFullYear()} All
                  Rights Reserved.
                </small>
              </div>
              <div className="privacy-policy">
                <a className="text-secondary" href="#">
                  <small>Terms and Conditions</small>
                </a>
                &nbsp;|&nbsp;
                <a className="text-secondary" href="#">
                  <small>Privacy Policy</small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
